import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, initializeFirestore, persistentLocalCache } from 'firebase/firestore';
import app from './firebaseCore';

export const auth = getAuth(app);
let dbInstance;
try {
  dbInstance = initializeFirestore(app, {
    localCache: persistentLocalCache(),
  });
} catch (error) {
  dbInstance = getFirestore(app);
}
export const db = dbInstance;
export const googleProvider = new GoogleAuthProvider();

export default app;
